import { execUrlFromString } from './validate'

const parsingLinkInComment = (commentContent: string) => {
    let newCommentContent = commentContent;
    let url;
    while ((url = execUrlFromString(commentContent)) !== null) {
      newCommentContent = newCommentContent.replace(
        url[0],
        `<a href="${url[0]}" target="_blank">${url[0]}</a>`
      );
    }

    return newCommentContent;
}

export default parsingLinkInComment;